export enum FgStockStatus {
    StockIn = 'StockIn',
    StockOut = 'StockOut',
    Cancelled = 'Cancelled',
}